import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import Ad from "@components/Advertisement/Ad";
import Breadcrumb from "@components/Breadcrumb/Breadcrumb";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import Header from "@components/Header/Header";
import { useBreadCrumbState } from "@components/Header/helpers";
import PulseEntry from "@features/pulse/components/PulseEntry/PulseEntry";
import BTLuxeHighlight from "@routes/Section/layouts/BTLuxe/components/BTLuxeHighlight";
import BTLuxeListing from "@routes/Section/layouts/BTLuxe/components/BTLuxeListing";
import { BTLuxePageData } from "@routes/Section/layouts/BTLuxe/utils/types";
import { getSeasonBasedOnDate } from "@routes/Section/layouts/Lifestyle/utils/helpers";
import { sectionNavigationItems } from "@util/constant";
import { cn } from "@util/helpers";
import dayjs from "dayjs";

import SeasonDivider from "./components/SeasonDivider";

const BTLuxePageContent = ({
  cardProps,
  seoFooterData,
}: BTLuxePageData): React.ReactElement => {
  const { breadcrumbsRef, isShowBreadCrumb } = useBreadCrumbState();

  const lifestyleUniqueName = RouteFactory.lifestyle.replace("/", "");
  const luxeUniqueName = RouteFactory.lifestyleLuxe.replace("/lifestyle/", "");

  const firstCardProps = cardProps[0];

  const today = new Date();
  const todaysSeason = getSeasonBasedOnDate(today.toString());

  return (
    <div className="w-full" data-testid="bt-luxe-page-content-component">
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header
        displayBreadcrumb={isShowBreadCrumb}
        parentCategory={lifestyleUniqueName}
        childCategory={luxeUniqueName}
        categoryDataMapping={sectionNavigationItems}
      />

      <PulseEntry />

      <Container>
        <h1 className="pb-3 pt-6 font-playfair text-8xl font-semibold text-gray-850">
          <span className="text-10xl">L</span>IFESTYLE
        </h1>

        <div ref={breadcrumbsRef}>
          <Breadcrumb
            className="container m-auto"
            parentCategory={lifestyleUniqueName}
            childCategory={luxeUniqueName}
            categoryDataMapping={sectionNavigationItems}
            extraBreadcrumbItems={
              <div
                className={cn(
                  "relative box-border flex shrink-0 items-center border-r border-gray-175 pr-3 font-poppins text-sm tracking-tightest text-gray-850 hover:opacity-80"
                )}
              >
                <Link
                  to={`${RouteFactory.lifestyle}?ref=listing-menubar`}
                  reloadDocument
                >
                  Top stories
                </Link>
              </div>
            }
          />
        </div>
      </Container>

      <Container rootClassName="pb-8">
        <BTLuxeHighlight cardProp={firstCardProps} className="mt-7" />

        <SeasonDivider
          season={todaysSeason}
          year={dayjs(today).year()}
          className="col-span-1 lg:col-span-6"
        />

        <BTLuxeListing
          articleIds={cardProps.map(({ id }) => id.toString())}
          cardProps={cardProps.slice(1)}
          todaysSeason={todaysSeason}
        />
      </Container>

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />
      <Ad adType="prestitial" />
    </div>
  );
};

export default BTLuxePageContent;
